/*
 * @Description: Controller 列表
 * @Author: yy
 * @LastEditors: yangyang yyangacom@163.com
 * @Date: 2019-02-21 14:06:22
 * @LastEditTime: 2023-12-06 10:03:58
 */

import http from './http'

export const IconUrl = id => {
  if ( !!id ) {
    return `http://back.dbrank.net/digitalAssets/resources/img/LOGO/${id}.png`
  }
  return 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
};

export const login = (data) => http.Post('/digitalAssets/login', data);
export const logout = (data) => http.Post('/digitalAssets/logout', data);
export const register = (data) => http.Post('/digitalAssets/register', data);
export const updatePwd = (data) => http.Post('/digitalAssets/update_pwd', data);
export const updateUser = (data) => http.Post('/digitalAssets/update_user', data);
export const getUser = (data) => http.Post('/digitalAssets/get_user', data);
export const checkPhone = (data) => http.Get('/digitalAssets/check_phone', data);
export const getPhoneCode = (data) => http.Post('/digitalAssets/get_phone_code', data);
export const checkImgCode = (data) => http.Post('/digitalAssets/check_img_code', data);
export const getBrandName = (data) => http.Get('/digitalAssets/s', data);
export const getP2NumberInfo = (data) => http.Get('/digitalAssets/getP2NumberInfo', data);
export const getReportDB = (data) => http.Get('/digitalAssets/report/getReportDB', data);
export const getKOL = (data) => http.Get('/digitalAssets/center/kol_participate_seg', data);
export const getReportOneDayDB = (data) => http.Get('/digitalAssets/report/getReportOneDayDB', data);
export const getReportOneDayDimensions = (data) => http.Get('/digitalAssets/report/getReportOneDayDimensions', data);
export const getReportBattleDB = (data) => http.Get('/digitalAssets/report/getReportBattleDB', data);
export const getReportBattleDimensions = (data) => http.Get('/digitalAssets/report/getReportBattleDimensions', data);
export const getReportOneDayDBCount = (data) => http.Get('/digitalAssets/report/getReportOneDayDBCount', data);
export const getCompareBrands = (data) => http.Get('/digitalAssets/center/getCompareBrands', data);
export const getBrandDetail = (data) => http.Get('/digitalAssets/center/brandDetail', data);
export const getBrandIndustry = (data) => http.Get('/digitalAssets/center/getBrandIndustry', data);
export const getContentNum = (data) => http.Get('/digitalAssets/getContentNum', data);
export const getBrandAndDataLength = (data) => http.Get('/digitalAssets/getBrandAndDataLength', data);
export const getChampionJsonDay = (data) => http.Get('/digitalAssets/getChampionJsonDay', data);
export const getChampionJsonDayCard = (data) => http.Get('/digitalAssets/getChampionJsonDayCard', data);
export const getChampionJsonWeek = (data) => http.Get('/digitalAssets/getChampionJsonWeek', data);
export const getChampionJsonWeekCard = (data) => http.Get('/digitalAssets/getChampionJsonWeekCard', data);
export const getChampionJsonMonth = (data) => http.Get('/digitalAssets/getChampionJsonMonth', data);
export const getChampionJsonMonthCard = (data) => http.Get('/digitalAssets/getChampionJsonMonthCard', data);
export const getIndustryJsonDay = (data) => http.Get('/digitalAssets/getIndustryJsonDay', data);
export const getIndustryJsonDayCard = (data) => http.Get('/digitalAssets/getIndustryJsonDayCard', data);
export const getIndustryJsonWeek = (data) => http.Get('/digitalAssets/getIndustryJsonWeek', data);
export const getIndustryJsonWeekCard = (data) => http.Get('/digitalAssets/getIndustryJsonWeekCard', data);
export const getIndustryJsonMonth = (data) => http.Get('/digitalAssets/getIndustryJsonMonth', data);
export const getIndustryJsonMonthCard = (data) => http.Get('/digitalAssets/getIndustryJsonMonthCard', data);
export const getPlatformJsonDay = (data) => http.Get('/digitalAssets/getPlatformJsonDay', data);
export const getPlatformJsonDayCard = (data) => http.Get('/digitalAssets/getPlatformJsonDayCard', data);
export const getPlatformJsonWeek = (data) => http.Get('/digitalAssets/getPlatformJsonWeek', data);
export const getPlatformJsonWeekCard = (data) => http.Get('/digitalAssets/getPlatformJsonWeekCard', data);
export const getPlatformJsonMonth = (data) => http.Get('/digitalAssets/getPlatformJsonMonth', data);
export const getPlatformJsonMonthCard = (data) => http.Get('/digitalAssets/getPlatformJsonMonthCard', data);
export const getGeoJsonDay = (data) => http.Get('/digitalAssets/getGeoJsonDay', data);
export const getGeoJsonDayCard = (data) => http.Get('/digitalAssets/getGeoJsonDayCard', data);
export const getGeoJsonWeek = (data) => http.Get('/digitalAssets/getGeoJsonWeek', data);
export const getGeoJsonWeekCard = (data) => http.Get('/digitalAssets/getGeoJsonWeekCard', data);
export const getGeoJsonMonth = (data) => http.Get('/digitalAssets/getGeoJsonMonth', data);
export const getGeoJsonMonthCard = (data) => http.Get('/digitalAssets/getGeoJsonMonthCard', data);
export const getIndustryList = (data) => http.Get('/digitalAssets/getIndustryList', data);

// 图表
// 心智占有率
export const getShareOfMind = (data) => http.Get('/digitalAssets/center/mind_share', data);
export const getComparisonMindShare = (data) => http.Get('/digitalAssets/center/comparison/mind_share', data);
// DB值构成图
export const getConsistOfDB = (data) => http.Get('/digitalAssets/center/consistOfDB', data);
export const getComparisonConsistOfDB = (data) => http.Get('/digitalAssets/center/comparison/new/consistOfDB', data);
// 历史曲线图
export const getHistoryGraphs = (data) => http.Get('/digitalAssets/center/historyGraphs', data);
export const getComparisonHistoryGraphs = (data) => http.Get('/digitalAssets/center/comparison/new/historyGraphs', data);
// 品牌三维图
export const getGraphicModel = (data) => http.Get('/digitalAssets/center/graphicModel', data);
export const getComparisonGraphicModel = (data) => http.Get('/digitalAssets/center/comparison/new/graphicModel', data);
// 三维曲线图
export const getTripleGraphs = (data) => http.Get('/digitalAssets/center/tripleGraphs', data);
export const getComparisonTripleGraphs = (data) => http.Get('/digitalAssets/center/comparison/new/tripleGraphs', data);
// KOL参与图
export const getKolParticipate = (data) => http.Get('/digitalAssets/center/kol_participate', data);
export const getComparisonKolParticipate = (data) => http.Get('/digitalAssets/center/comparison/new/kol_participate', data);
// 口碑舆情图
export const getWordOfMouth = (data) => http.Get('/digitalAssets/center/back/public_deep_sea', data);
export const getComparisonPublicDeepSea = (data) => http.Get('/digitalAssets/center/comparison/new/public_deep_sea', data);
// 受众好感图
export const getUserFeelings = (data) => http.Get('/digitalAssets/center/public_favor_seg', data); 
export const getUserParticipate = (data) => http.Get('/digitalAssets/center/comparison/new/public_favor_seg', data); 
export const getUserFeelingsNoBeginTime = (data) => http.Get('/digitalAssets/center/public_favor', data); 
export const getUserParticipateNoBeginTime = (data) => http.Get('/digitalAssets/center/comparison/new/public_favor', data); 

// 文章管理
export const deleteArticle = (data) => http.Get('/digitalAssets/delete_article', data);
export const updateBrandEmotion = (data) => http.Get('/digitalAssets/article/update_brand_emotion', data);
// 获取文章列表-mongo
export const doChangeMongoArticle = (data) => http.Post('/digitalAssets/report/doChangeMongoArticle', data, {
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
});
export const getReportKeyWorldArticle = (data) => http.Get('/digitalAssets/report/getReportKeyWorldArticle', data);
export const getReportBrandV = (data) => http.Get('/digitalAssets/report/getReportBrandV', data);
export const doAddReportBrandV = (data) => http.Get('/digitalAssets/report/doAddReportBrandV', data);
export const doChangeReportBrandV = (data) => http.Get('/digitalAssets/report/doChangeReportBrandV', data);
export const doDelReportBrandV = (data) => http.Get('/digitalAssets/report/doDelReportBrandV', data);
export const doChangeEmotionReportBrandV = (data) => http.Get('/digitalAssets/report/doChangeEmotionReportBrandV', data);
export const getBrandTree = (data) => http.Get('/digitalAssets/getBrandTree', data)
export const getBrandWords = (data) => http.Get('/digitalAssets/getBrandWords', data)
export const updateWords = (data) => http.Get('/digitalAssets/updateWords', data)

// SO-ME 
export const getCarBrandIndexRank = (data) => http.Get('/so_me/getCarBrandIndexRank', data)
export const getCarProductIndexRank = (data) => http.Get('/so_me/getCarProductIndexRank', data)
export const getConsumeIndexRank = (data) => http.Get('/so_me/getConsumeIndexRank', data)
export const getScienceIndexRank = (data) => http.Get('/so_me/getScienceIndexRank', data)
export const getPeriods = (data) => http.Get('/so_me/getPeriods', data)

// cms
// 获取文章列表-mysql
export const getKolList = (data) => http.Get('/dbrankCMS/getKolList', data);
export const getBrandInfo = (data) => http.Get('/dbrankCMS/getBrandInfo', data)
export const getArticleList = (data) => http.Get('/dbrankCMS/getArticleList', data)
export const getIndustryInfo = (data) => http.Get('/dbrankCMS/getIndustryInfo', data)
export const updateBrandName = (data) => http.Get('/dbrankCMS/updateBrandName', data)
export const updateBrandWords = (data) => http.Get('/dbrankCMS/updateBrandWords', data)
export const addResearchReport = (data) => http.Get('/dbrankCMS/addResearchReport', data)
export const deleteResearchReport = (data) => http.Get('/dbrankCMS/deleteResearchReport', data)
export const updateResearchReport = (data) => http.Get('/dbrankCMS/updateResearchReport', data)
export const setStickResearchReport = (data) => http.Get('/dbrankCMS/setStickResearchReport', data)
export const getResearchReportByUrl = (data) => http.Get('/dbrankCMS/getResearchReportByUrl', data)
export const doChangeBrandInfo = (data, id) => http.Post(`/dbrankCMS/doChangeBrandInfo?id=${id}`, data)
export const getResearchReportList = (data) => http.Get('/dbrankCMS/getResearchReportList', data)
export const checkReport = (data) => http.Get('/dbrankCMS/checkReport', data)
// export const addResearchReportPicture = (data) => http.Post('/uploadA/addResearchReportPicture', data)
export const addResearchReportPicture = (data) => http.Post('/dbrankCMS/addResearchReportPicture', data)

export const getDataFromServerInterface = (data) => http.Get('/getDataFromServerInterface', data);

export const saasBrandDBGetBrandDBList = (data) => http.Post('/saas/BrandDB/getBrandDBList', data, {
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})
export const saasBrandDBSaveBrandDBList = (data) => http.Post('/saas/BrandDB/saveBrandDBList', data, {
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  },
  blob: true
})

export const getVisual = (page) => http.Get(`${location.origin}/visual/p${page}.csv`)



// WEBPACK FOOTER //
// src/controller/index.js